import classNames from 'classnames'

import { useCountdown } from 'hooks/useCountdown'
import { Input } from '../../components/ui/Input/Input'
import { useCallback, useMemo, useState } from 'react'
import { Button } from 'components/ui/Button/Button'

interface Props {
  otp?: string
  isLoading: boolean
  handleOnSubmit(code: string): Promise<void>
  handleOnResend(): Promise<void>
}

export const OTPForm = ({ otp, isLoading, handleOnSubmit, handleOnResend }: Props) => {
  const { tick, fired, reset } = useCountdown(59)
  const [code, setCode] = useState<string>('')

  const formattedTick = useMemo((): string => {
    if (tick < 10) return `0${tick}`
    return tick.toString()
  }, [tick])

  const handleOnInputOtp = useCallback(
    async (otpCode: string) => {
      if (otpCode.length > 4) return
      setCode(code)
      if (otpCode.length === 4) {
        await handleOnSubmit(otpCode)
      }
    },
    [handleOnSubmit]
  )

  const handleClick = useCallback(async () => {
    await handleOnResend()
    reset()
  }, [handleOnResend, reset])

  const textClassName = classNames('login-form__timer text--gray', { 'visually-hidden': fired })

  return (
    <div className="login-form">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="login-form__form">
          <div className="login-form__row">
            <Input
              onChange={handleOnInputOtp}
              labelText="Введите код"
              placeHolder={otp}
              value={code}
            />
          </div>
          <div className="login-form__button-container center">
            <Button
              handleOnSubmit={handleClick}
              title="Запросить код"
              disabled={!fired}
              isLoading={isLoading}
            />
          </div>
          <div className={textClassName}>
            <span>До повтороной отправки кода</span>
            <span className="login-form__timer-ticker">00:{formattedTick}</span>
          </div>
        </div>
      </form>
    </div>
  )
}
